import {BaseService} from "./BaseService";
import {Scanner} from '../entities/Scanner'
import { StateService } from "@uirouter/angularjs";

export class ScannerService extends BaseService<Scanner>{
    static $inject = ['$http','$q', '$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, Scanner);
    }
    protected getBaseUrl():string{
        return "scanner";
    }
    getByDeviceID(deviceId: string): ng.IPromise<Scanner> {
        // Modified 022519 by BA to put name as a query parameter to handle special characters (# and %)
        return this.useBaseGetHandler(this.getBaseUrl(), "deviceID?deviceID=" + encodeURIComponent(deviceId), {});
    }
    activate(deviceId: string): ng.IPromise<Scanner> {
        // Modified 022519 by BA to put name as a query parameter to handle special characters (# and %)
        return this.usePostHandler(this.getBaseUrl(), "activate?deviceID=" + encodeURIComponent(deviceId), {});
    }
    deactivate(deviceId: string): ng.IPromise<Scanner> {
        // Modified 022519 by BA to put name as a query parameter to handle special characters (# and %)
        return this.usePostHandler(this.getBaseUrl(), "deactivate?deviceID=" + encodeURIComponent(deviceId), {});
    }
}
